module.exports = __webpack_public_path__ + "img/picture_viptk03.6c62d0a5.png";